export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  { width: 40, align: 'center', fixed: 'left', type: 'checkbox' },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 110,
    fixed: 'left',
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'pointNo',
    align: 'center',
    fixed: 'left',
    width: 140,
    title: '门点编号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
    sortType: 'string',
  },
  {
    field: 'pointName',
    headerAlign: 'center',
    align: 'left',
    width: 180,
    title: '门点名称',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
    sortType: 'string',
  },
  {
    field: 'custShortName',
    headerAlign: 'center',
    align: 'left',
    width: 120,
    title: '客户',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
    sortType: 'string',
  },

  {
    field: 'pointTypeName',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: '门点类型',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
    sortType: 'string',
  },
  {
    field: 'provinceName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 120,
    title: '省份',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
    sortType: 'string',
  },
  {
    field: 'cityName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 120,
    title: '城市',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
    sortType: 'string',
  },
  {
    field: 'districtName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 120,
    title: '区县',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
    sortType: 'string',
  },
  {
    field: 'detailAddress',
    headerAlign: 'center',
    align: 'left',
    minWidth: 230,
    title: '详细地址',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'contactName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 120,
    title: '联系人',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
    sortType: 'string',
  },
  {
    field: 'contactMobile',
    headerAlign: 'center',
    align: 'left',
    minWidth: 140,
    title: '联系人手机',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'contactEmail',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    title: '联系人邮箱',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'tdpPointNo',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    title: '三方门点编号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'pointFence',
    align: 'center',
    width: 100,
    title: '电子围栏半径',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'pointStatusName',
    align: 'center',
    width: 100,
    title: '状态',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    slots: { default: 'status' },
  },
  {
    headerAlign: 'center',
    field: 'createByName',
    title: '创建人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'createTime',
    title: '创建时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
  },
  {
    headerAlign: 'center',
    field: 'modifyByName',
    title: '修改人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'modifyTime',
    title: '修改时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: false,
  },
]
